import { Logger } from 'src/utils/Logger';
import { AuthPageLayout } from 'src/auth/components/AuthPageLayout';
import { showError } from 'src/toasts/toasts';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { Text, Button, Stack } from '@mantine/core';
import { useLogout } from 'src/auth/hooks/useLogout';

export const SsoMismatchPage = () => {
  const { mutate: logout } = useLogout({
    onError: error => {
      Logger.error('Log out failed', error);
      showError('Something went wrong while trying to log you out. Please try again.');
    },
  });

  const handleLogout = async () => logout();

  return (
    <AuthPageLayout withHeader>
      <Stack maw={500}>
        <Text c={'gray.1'} size="displayMd" fw={FONT_WEIGHTS.semibold} ta="center">
          {"We couldn't sign you in"}
        </Text>

        <Text c={'gray.1'} fz="md" fw={FONT_WEIGHTS.medium} ta="center">
          {"The email address you signed in with doesn't match the email on your account. " +
            'This usually happens when you sign in with a different Google or Microsoft account than the one matching your account email.'}
        </Text>
        <Text c={'gray.1'} fz="md" fw={FONT_WEIGHTS.medium} ta="center">
          Please log out and contact support at support@afternoon.co.uk so we can help resolve this.
        </Text>

        <Button mt={'xxl'} onClick={handleLogout} fullWidth variant="primary">
          Log out
        </Button>
      </Stack>
    </AuthPageLayout>
  );
};
